import { useState } from 'react';

import { PAYMENT_FILTER_OPTIONS } from '../utils/paymentCategories';

export default function usePaymentUiState() {
  const [showSuartePlusPopup, setShowSuartePlusPopup] = useState(false);
  const [showGalleryPaymentModal, setShowGalleryPaymentModal] = useState(false);
  const [showSeatPaymentModal, setShowSeatPaymentModal] = useState(false);
  const [showCancelSuartePlusPopup, setShowCancelSuartePlusPopup] = useState(false);
  const [showSupportCancelPopup, setShowSupportCancelPopup] = useState(false);
  const [supportCancellationTarget, setSupportCancellationTarget] = useState(null);
  const [activeSupportActionMenuId, setActiveSupportActionMenuId] = useState(null);
  const [activeChannelActionMenuId, setActiveChannelActionMenuId] = useState(null);
  const [activePaymentActionMenuId, setActivePaymentActionMenuId] = useState(null);
  const [paymentFilter, setPaymentFilter] = useState(PAYMENT_FILTER_OPTIONS[0]);
  const [summaryTarget, setSummaryTarget] = useState(null);
  const [invoiceTarget, setInvoiceTarget] = useState(null);
  const [invoiceStatusMessage, setInvoiceStatusMessage] = useState(null);
  const [invoiceBillingRequired, setInvoiceBillingRequired] = useState(false);
  const [invoiceActionLoadingOrderId, setInvoiceActionLoadingOrderId] = useState(null);
  const [channelRevokeTarget, setChannelRevokeTarget] = useState(null);
  const [channelRevokePopupOpen, setChannelRevokePopupOpen] = useState(false);
  const [businessBillingTarget, setBusinessBillingTarget] = useState(null);

  return {
    showSuartePlusPopup, setShowSuartePlusPopup, showGalleryPaymentModal, setShowGalleryPaymentModal,
    showSeatPaymentModal, setShowSeatPaymentModal, showCancelSuartePlusPopup, setShowCancelSuartePlusPopup,
    showSupportCancelPopup, setShowSupportCancelPopup, supportCancellationTarget, setSupportCancellationTarget,
    activeSupportActionMenuId, setActiveSupportActionMenuId, activeChannelActionMenuId, setActiveChannelActionMenuId,
    activePaymentActionMenuId, setActivePaymentActionMenuId, paymentFilter, setPaymentFilter,
    summaryTarget, setSummaryTarget, invoiceTarget, setInvoiceTarget, invoiceStatusMessage, setInvoiceStatusMessage,
    invoiceBillingRequired, setInvoiceBillingRequired, invoiceActionLoadingOrderId, setInvoiceActionLoadingOrderId,
    channelRevokeTarget, setChannelRevokeTarget, channelRevokePopupOpen, setChannelRevokePopupOpen,
    businessBillingTarget, setBusinessBillingTarget,
  };
}
